<template>
  <transition name="present-sticky-transition" v-if="isPageScrolled">
    <div class="present-sticky">
      <div class="present-sticky__wrapper">
        <img
          class="present-sticky__photo"
          :class="`--is-size-${currentBox.products.filter(p => p.type === 'box')[0].name.slice(-1).toLowerCase()}`"
          :src="currentBox.images_hd[0][0]"
        >

        <div class="present-sticky__info">
          <h3 class="present-sticky__title">{{ currentBox.name }} <span>inkl. handgeschriebener Grußkarte</span></h3>

          <div class="present-sticky__cta">
            <Price align="left" class="present-sticky__price">
              <template v-slot:brutto>{{ getPriceForGroup(currentBox, $store.getters.getUserGroupId, false) }}</template>
              <template v-slot:netto>{{ getPriceForGroup(currentBox, $store.getters.getUserGroupId, true) }}</template>
            </Price>

            <Button
              size="large"
              appearance="primary"
              class="present__cta-button"
              @click="scrollTo('present-main')"
              :disabled="!selectedIsInList()"
            >Konfigurieren</Button>
          </div>
        </div>

        <button
          @click="dismiss()"
          type="button"
          class="present-sticky__close"
        >
          <i class="icon icon-times"></i>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import debounce from 'lodash.debounce';

import { logicMixin } from '@/mixins/LogicMixin';
import { UiMixin } from '@/mixins/UiMixin';

import Price from '@/components/Common/Price';
import Button from '@/components/Common/Button';

export default {
  name: 'PresentSticky',
  mixins: [logicMixin, UiMixin],
  components: {
    Price,
    Button
  },
  data () {
    return {
      isPageScrolled: false,
      isDismissed: false,
    };
  },
  computed: {
    currentBox () {
      return this.$store.getters.getSelectedItem.data;
    },
  },
  methods: {
    handleScroll () {
      if (this.isDismissed) {
        return;
      }

      if (
        !this.isInScrollView(document.getElementById('present-main')) &&
        !this.isInScrollView(document.getElementById('explore')) &&
        !this.isInScrollView(document.getElementById('contact')) &&
        !this.isInScrollView(document.getElementById('footer'))
      ) {
        this.isPageScrolled = true;
      } else {
        this.isPageScrolled = false;
      }
    },

    dismiss () {
      this.isPageScrolled = false;
      this.isDismissed = true;
    },

    selectedIsInList() {
      var isIn = false;
      this.$store.getters.getListItemsLevel1Filtered.forEach(element => {
        if (element.id === this.$store.getters.getSelectedItem.data.id) {
          isIn = true;
        }
      });
      return isIn;
    }
  },
  mounted () {
    this.handleDebouncedScroll = debounce(this.handleScroll, 50);

    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  }
};
</script>

<style lang="scss" scoped>
/**
 * PresentSticky
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present sticky bar that appears when scrolling
 * @since 2021-03-24
**/

$component: 'present-sticky';

.#{$component} {
  width: auto;
  position: fixed;
  @include rfs(map-get($spacers, 5), right);
  @include rfs(map-get($spacers, 5), bottom);
  z-index: 9;
  border-radius: $border-radius-lg;
  background-color: $white;
  box-shadow: 5px 5px 30px rgba($ink, 0.3);
  will-change: transform;

  &__wrapper {
    position: relative;
    display: flex;
    width: 100%;
    align-items: flex-start;
    @include padding(map-get($spacers, 4));
  }

  &__photo {
    @include rfs(8rem, max-width);
    @include margin-top(- map-get($spacers, 3));
    @include margin-right(map-get($spacers, 4));
    @include margin-bottom(- map-get($spacers, 5));

    &.--is-size-s {
      margin-top: unset;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__title {
    @include margin-bottom(map-get($spacers, 3));

    span {
      display: block;
      @include margin-top(map-get($spacers, 1));
      @include font-size($font-size-lg);
      font-weight: $font-weight-normal;
      color: $ink-lighter;
    }
  }

  &__cta {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }

  &__cta {
    @include margin-right(map-get($spacers, 4));
  }

  &__close {
    position: absolute;
    @include rfs(map-get($spacers, 2), top);
    @include rfs(map-get($spacers, 2), right);
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    color: $sky-dark;
    @include font-size($font-size-lg * 2);
    line-height: 1;

    &:hover {
      color: $ink-lightest;
    }
  }

  @at-root {
    /* Present Sticky Transition */
    .present-sticky-transition-enter-active, .present-sticky-transition-leave-active {
      transition: all 0.3s ease-in-out;
      opacity: 1;
    }
    .present-sticky-transition-enter, .present-sticky-transition-leave-to {
      transform: translateX(20rem);
      opacity: 0;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    @include rfs(map-get($spacers, 2), right);
    @include rfs(map-get($spacers, 2), bottom);
    @include rfs(map-get($spacers, 2), left);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &__photo {
      display: none;
      @include rfs(12rem, max-width);
    }

    @at-root {
      .present-sticky-transition-enter, .present-sticky-transition-leave-to {
        transform: translateX(0) translateY(20rem);
      }
    }
  }
}
</style>
